import httpApi from '@/http/api'

const DEFAULT_BRAND = '国际物流'
let loading = null

export function getBrand() {
  const t = sessionStorage.getItem('title')
  return (t && t.trim()) ? t.trim() : DEFAULT_BRAND
}

export function applyDocumentTitle(pageTitle) {
  const brand = getBrand()
  if (pageTitle) {
    document.title = `${pageTitle} - ${brand}`
  } else {
    document.title = `用户登录 - ${brand}`
  }
}

function applyFavicon(ico) {
  if (!ico) return
  const link = document.querySelector("link[rel*='icon']") || document.createElement('link')
  link.type = 'image/x-icon'
  link.rel = 'shortcut icon'
  link.href = ico
  document.getElementsByTagName('head')[0].appendChild(link)
}

/** 写入已拿到的 sys_config（登录页/公共页共用） */
export function saveSysBrand(config) {
  if (!config) return getBrand()
  if (config.title && String(config.title).trim()) {
    sessionStorage.setItem('title', String(config.title).trim())
  }
  if (config.ico) {
    sessionStorage.setItem('ico', config.ico)
    applyFavicon(config.ico)
  }
  return getBrand()
}

/**
 * 若本地尚无系统名称，则请求 sys_config（管理端 list 对 sys_config 免登录）。
 * 已有缓存则直接返回，避免重复请求。
 */
export function ensureSysBrand() {
  const cached = sessionStorage.getItem('title')
  if (cached && cached.trim()) {
    return Promise.resolve(cached.trim())
  }
  if (loading) return loading
  loading = httpApi
    .listParams({
      params: {
        type: 'sys_config',
        enable: '1'
      }
    })
    .then((res) => {
      if (res.data.code === 'ok' && res.data.data && res.data.data.length > 0) {
        return saveSysBrand(res.data.data[0])
      }
      return DEFAULT_BRAND
    })
    .catch(() => DEFAULT_BRAND)
    .finally(() => {
      loading = null
    })
  return loading
}
